export default __webpack_public_path__ + "static/media/lucia_santos.3631853b.gif";